import Address from './Address';
import * as _ from 'lodash';
import Model from './Model';
import UserBase from './Base/UserBase';
import Product from './Product';
import Customer from './Customer';
import Courier from './Courier';
import * as moment from "moment";

class User extends UserBase {
	constructor(options) {
		super(options);
		this.bind(options);
	}
}

class Order extends Model {
	user: (d: any) => void;
  order_id: String;
	constructor(options) {
		super();

		(this as any).user = d => {
			return new User(d.data);
		};

		(this as any).products = d => {
			return _.map(d.data, item => new Product(item));
		};

		(this as any).addresses = d => {
			return _.map(d.data, item => new Address(item));
		};

		(this as any).shipping_address = d => {
			return new Address(d.data);
		};

		(this as any).billing_address = d => {
			return new Address(d.data);
		};

		(this as any).customer = d => {
			return new Customer(d.data);
		};

    (this as any).courier = d => {
      return new Courier(d.data);
    };
		this.bind(options);
	}

	getFullName() {
		return (this as any).first_name + ' ' + (this as any).last_name;
	}
  getReturnItem() {
	  if ((this as any).products) {
      return (this as any).products.filter(product => !!product.order_product.return_status_id);
    } else {
	    return [];
    }
  }
  getName(type) {
    if ((this as any)[type]) {
      let firstName = (this as any)[type].first_name ? (this as any)[type].first_name : '';
      let lastName = (this as any)[type].last_name ? (this as any)[type].last_name : '';
      return `${firstName} ${lastName}`;
    }
    return '';
  }
  getEmail() {
    return (this as any).user ? (this as any).user.email : (this as any).email;
  }
  getUserId() {
    return (this as any).user ? (this as any).user.id : '';
  }
  getShippingName() {
    return this.getName('shipping_address');
  }
  getBillingName() {
    return this.getName('billing_address');
  }
  getTitle() {
    return this.order_id;
  }

  getPathIdentifier() {
    return this.order_id;
  }
  getLastPrintedDateMoment() {
    if (!this['last_printed_date']) {
      return null;
    }
    let m = moment(this['last_printed_date']);
    return m;
  }
}

export default Order;
